new Vue({
    el:".pro1_bot",
    data(){
        return{
            arr:productsData,
            showMnav:false,
            navText:['XLIM Series','NeXLIM Series','SLIMSTICK Series','VPRIME Series','PLATFORM','OTHERS'],
            navIndex:0,
            activeItem:''
        }
    },
    created(){
        if(window.location.href.indexOf('?id')!==-1){
            var urlParams = new URLSearchParams(window.location.search);
            var id = urlParams.get('id');
            if(id){
                this.navIndex = id-1
            }
        }
    }
})